import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogContent} from "@angular/material/dialog";
import {TranslateService, TranslatePipe} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {CdkScrollable} from "@angular/cdk/scrolling";
import {EscapeHotkeyDirective} from "../../../../../shared/hotkey/directives/escape-hotkey.directive";

@Component({
	selector: "app-profile-map-extraction-popup",
	templateUrl: "./profile-map-extraction-popup.component.html",
	styleUrls: ["./profile-map-extraction-popup.component.scss"],
	imports: [MatIcon, CdkScrollable, MatDialogContent, EscapeHotkeyDirective, TranslatePipe],
})
export class ProfileMapExtractionPopupComponent {
	constructor(
		public dialogRef: MatDialogRef<ProfileMapExtractionPopupComponent>,
		public translate: TranslateService,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {
		this.dialogRef.addPanelClass("mep-dialog");
	}

	getSkillName(skill: any): string {
		if (!skill) {
			return "";
		}
		return skill.skillName || skill.skillNameDe || skill.skillNameEn || skill.skillNameAlt || "";
	}

	onAccept() {
		this.dialogRef.close(true);
	}
}
